const PASSWORD_PATHS = new Set(["/account/reset", "/account/welcome"]);

function paramsFromFragment(fragment = "") {
  return new URLSearchParams(fragment.replace(/^[?#]/, ""));
}

export function isPasswordPath(pathname = "") {
  return PASSWORD_PATHS.has(pathname);
}

export function isRecoveryRedirect({ pathname = "", search = "", hash = "" } = {}) {
  const query = paramsFromFragment(search);
  const fragment = paramsFromFragment(hash);
  const authType = fragment.get("type") ?? query.get("type");
  return isPasswordPath(pathname) || authType === "recovery" || authType === "invite";
}

export function getAuthRedirectError({ search = "", hash = "" } = {}) {
  const query = paramsFromFragment(search);
  const fragment = paramsFromFragment(hash);
  const error = fragment.get("error") ?? query.get("error");
  if (!error) return "";
  return fragment.get("error_description") ?? query.get("error_description") ?? "The secure link could not be verified.";
}
